import { render, staticRenderFns } from "./DisplayCaseStudies.vue?vue&type=template&id=1c75b77a&scoped=true"
import script from "./DisplayCaseStudies.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayCaseStudies.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DisplayCaseStudies.vue?vue&type=style&index=0&id=1c75b77a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c75b77a",
  null
  
)

export default component.exports